<div id="ht">
    <div id="main-cnt">
        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back"><span class="custom-icon-back-arrow-icon" (click)="back()"><span
                            class="path1"></span><span class="path2"></span></span><span
                            class="breadcrumb">Support</span></div>
                </ion-buttons>
                <div slot="end" class="notification-div">
                    <app-add-bookmark pageTitle="Supporto" url="/support"></app-add-bookmark>
                    <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')"><img
                            [src]="sessionService?.user?.profileImg|s3Link"/></ion-avatar>
                </div>
            </ion-toolbar>
            <ion-toolbar class="blues-nav panel-buttons-container">
                <ion-segment value="msg" [(ngModel)]="segment" (ionChange)="segmentChanged($event)" class="" color="white" mode="md">
                    <ion-segment-button class="" value="msg"  >
                        <ion-label>Messaggi</ion-label>
                    </ion-segment-button>
                    <ion-segment-button class="" value="archived">
                        <ion-label>Archiviati</ion-label>
                    </ion-segment-button>
                </ion-segment>

            </ion-toolbar>
            <br/></ion-header>
        <ion-content class="main-dcontent">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content"><!-- edit da qui... -->
                        <!-- <app-support-chat [ticketId]="sessionService.user.id" *ngIf="sessionService.user.permessions == sessionService.permessionTypes.CLIENT" ></app-support-chat> -->
                        <!-- <ion-list *ngIf="sessionService.user.permessions == sessionService.permessionTypes.COMMERCIAL" > -->
                        <ion-list *ngIf="segment === 'msg' ">
                            <ion-item-sliding *ngFor="let chat of allChats" class="ion-padding-bottom"
                                             >
                                <ion-item class="glass-blurred-background drop-shadow color-white"  (click)="goToAgentChat(chat.id)">
                                    <ion-grid>
                                        <ion-row>
                                            <div class="toAnswer"  *ngIf="chat.isClient"></div>
                                            <ion-col size="12">{{chat.title}}</ion-col>
                                        </ion-row>
                                        <ion-row>
                                            <ion-col size="8"><small
                                                    *ngIf="sessionService.user?.permessions !== sessionService.permessionTypes.CLIENT">Cliente: {{chat.client?.name |titlecase}} {{chat.client?.lastname |titlecase}}</small>
                                            </ion-col>
                                            <ion-col><small>{{chat.createdAt | date: "dd/MM/yy HH:mm" }}</small>
                                            </ion-col>
                                        </ion-row>
                                        <ion-row>
                                            <ion-col size="12">{{chat.messsage.substr(0, 70)}}</ion-col>
                                        </ion-row>
                                    </ion-grid>
                                </ion-item>
                                <ion-item-options side="end" class="ion-padding-bottom">
                                    <ion-item-option color="danger" (click)="archive(chat.id)">
                                        <ion-icon slot="icon-only" name="archive-outline"></ion-icon>
                                    </ion-item-option>
                                </ion-item-options>
                            </ion-item-sliding>
                        </ion-list>
                        <ion-list *ngIf="segment === 'archived' ">
                            <ion-item-sliding *ngFor="let chat of archivedChats" class="ion-padding-bottom"
                                              >
                                <ion-item class="glass-blurred-background drop-shadow color-white" (click)="goToAgentChat(chat.id)">

                                    <ion-grid>

                                        <ion-row>

                                            <ion-col size="12">{{chat.title}}</ion-col>
                                        </ion-row>
                                        <ion-row>
                                            <ion-col size="8"><small
                                                    *ngIf="sessionService.user?.permessions !== sessionService.permessionTypes.CLIENT">Cliente: {{chat.client?.name |titlecase}} {{chat.client?.lastname |titlecase}}</small>
                                            </ion-col>
                                            <ion-col><small>{{chat.createdAt | date: "dd/MM/yy HH:mm" }}</small>
                                            </ion-col>
                                        </ion-row>
                                        <ion-row>
                                            <ion-col size="12">{{chat.messsage.substr(0, 70)}}</ion-col>
                                        </ion-row>
                                    </ion-grid>
                                </ion-item>
                                <ion-item-options side="end" class="ion-padding-bottom">
                                    <ion-item-option color="success" (click)="unArrchive(chat.id)">
                                        <ion-icon slot="icon-only" name="archive-outline"></ion-icon>
                                    </ion-item-option>
                                </ion-item-options>
                            </ion-item-sliding>
                        </ion-list>
                        <div *ngIf="sessionService.user.permessions === sessionService.permessionTypes.CLIENT"
                             class="floating-btn drop-shadow" (click)="newTicket()">+
                        </div><!-- ...a qui --></div>
                </div>
            </div>
        </ion-content>
    </div>
</div>
